module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"mobile-phone-label":"Numéro de mobile","phone-label":"Numéro supplémentaire","placeholder":"06 12 34 56 78","errors":{"required":"Champ requis"}},"en":{"mobile-phone-label":"Mobile phone number","phone-label":"Additional phone number","placeholder":"06 12 34 56 78","errors":{"required":"Required field"}}}')
  delete Component.options._Ctor
}
